import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseUrl:"/api/swyl/v1/cost/bscCostDetail",

    //添加新费用试用条目
    insert(q){
        return http({
            url: this.baseUrl + '/insert',
            method: 'post',
            params: q
        });
    },

    updateById(q){
        return http({
            url: this.baseUrl + '/updateById',
            method: 'post',
            params: q
        });
    },

    selectById(q){
        return http({
            url: this.baseUrl + '/selectById',
            method: 'post',
            params: q
        });
    },

    //导表
    getCostDetailServiceForExcel(c){

        updownfile.down(this.baseUrl+'/getCostDetailServiceForExcel',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCostDetailServiceForExcel?companyName='+companyName+'&cdate='+cdate

    },
    getCostDetailServiceByTimePage(q){
        return http({
            url: this.baseUrl + '/getCostDetailServiceByTimePage',
            method: 'post',
            params: q
        });
    },

    getCostDetailById(q){
        return http({
            url: this.baseUrl + '/getCostDetailById',
            method: 'post',
            params: q
        });
    },

}